import { AdgroupFormData, NO_LIMIT } from '@tt4b/ttam-enums';
import { NetStateEnum, useStore, ValidationError } from '@tt4b/ttam-hooks';
import { computed, Ref } from '@vue/composition-api';
import { i18n } from './../../../i18n';

export function useDataSource() {
  const { getStore } = useStore();
  const { run: loadData } = getStore(NetStateEnum.languageList);
  return {
    loadData,
  };
}

export function usePropLanguageOptions() {
  const { getStore } = useStore();
  const { data: languageList } = getStore(NetStateEnum.languageList);
  const options = computed(() => languageList?.value?.map(({ code, label }) => ({ id: code, label })) || []);
  const languageOptions = computed(() => [...options.value]);

  return {
    languageOptions,
  };
}

export function usePropLanguageListName(options: { adgroupData: Ref<AdgroupFormData> }) {
  const { adgroupData } = options;
  const { languageOptions } = usePropLanguageOptions();
  const languageMap = computed(() =>
    languageOptions.value.reduce((pre, cur) => {
      pre[cur.id] = cur.label;
      return pre;
    }, {})
  );
  const languageListName = computed(() => adgroupData.value?.languageList?.map(item => languageMap.value[item]));
  return {
    languageListName,
  };
}
